import { Injectable } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";

import { DffFormControlType, DffOprindeligAktuelVaerdiFormGroup, DffReactiveFormControlValueMapper as Map } from "@dffedb/forms";

import { SendMailTilForbrugerData } from "./model/send-mail-til-forbruger-data.model";
import { SendMailTilForbruger } from "./model/send-mail-til-forbruger.model";

@Injectable({ providedIn: "root" })
export class SendMailTilForbrugerFormBuilder {
    public sendMailTilForbrugerDataToFormGroup(model: SendMailTilForbrugerData): UntypedFormGroup {
        const result = new UntypedFormGroup({
            sendMailTilForbruger: this.sendMailTilForbrugerToFormGroup(model.sendMailTilForbruger)
        });
        return result;
    }

    public sendMailTilForbrugerToFormGroup(model: SendMailTilForbruger): UntypedFormGroup {
        const emailValidators = [Validators.required, Validators.email];
        const email = new DffOprindeligAktuelVaerdiFormGroup(
            model.email,
            { controlType: DffFormControlType.TextInput, placeholder: "Forbrugerens e-mail" },
            model.emailFrabedes.aktuel ? [] : emailValidators
        );
        const emailFrabedes = new DffOprindeligAktuelVaerdiFormGroup(model.emailFrabedes, {
            controlType: DffFormControlType.Checkbox,
            placeholder: "Forbrugeren ønsker ikke e-mail tilsendt"
        });
        const result = new UntypedFormGroup({ email, emailFrabedes });

        emailFrabedes.valueChanges.subscribe((changes) => {
            email.get("aktuel").setValidators(changes.aktuel ? [] : emailValidators);
            email.get("aktuel").updateValueAndValidity();
        });

        return result;
    }

    public formGroupTilSendMailTilForbrugerData(formGroup: UntypedFormGroup): SendMailTilForbrugerData {
        const result: SendMailTilForbrugerData = {
            sendMailTilForbruger: this.formGroupTilSendMailTilForbruger(formGroup.get("sendMailTilForbruger") as UntypedFormGroup)
        };
        return result;
    }

    public formGroupTilSendMailTilForbruger(formGroup: UntypedFormGroup): SendMailTilForbruger {
        const email = Map.toOprindeligAktuelStrings(formGroup.get("email"));
        const emailFrabedes = Map.toOprindeligAktuelBooleans(formGroup.get("emailFrabedes"));
        const result: SendMailTilForbruger = {
            email,
            emailFrabedes
        };
        return result;
    }
}
